import { Grid, Stack, TextField } from '@mui/material';
import Button from '@mui/material/Button';
import { useEffect } from 'react';
import { SubmitHandler, useForm } from 'react-hook-form';
import { useTranslation } from '../../contexts/translation';
import { GroupInput } from '../../types/app/group.types';
interface Props {
  onSubmit: SubmitHandler<GroupInput>;
  defaultValues?: GroupInput;
  onBack: any;
}

export function GroupForm({ onSubmit, defaultValues, onBack }: Props) {
  const { t } = useTranslation();
  const {
    register,
    handleSubmit,
    formState: { errors },
    reset,
  } = useForm<GroupInput>();

  useEffect(() => {
    reset({ ...defaultValues });
  }, [defaultValues, reset]);

  return (
    <>
      <form onSubmit={handleSubmit(onSubmit)} noValidate>
        <Grid container spacing={1}>
          <Grid item xs={12}>
            <TextField
              required
              fullWidth
              label={t('page.group.edit-input-label-1')}
              {...register('name', { required: t('page.group.validation-required-name') })}
              error={Boolean(errors.name)}
              helperText={errors.name?.message}
              autoFocus
            />
          </Grid>
          <Grid item>
            <Stack spacing={2} direction="row">
              <Button type="button" variant="outlined" onClick={onBack}>
                {t('general.action-buttons.back')}
              </Button>
              <Button type="submit" variant="contained" color="success">
                {t('general.action-buttons.save')}
              </Button>
            </Stack>
          </Grid>
        </Grid>
      </form>
    </>
  );
}
